import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';
import { IRpaDashboardUIPathState } from 'app/rpa-bots/core/IRpaBots';

const uipathDashboardSelector = (state: IAppState) => state.rpaState.uiPathDashboard;

export const getUIPathJobsListSelector = createSelector(
    uipathDashboardSelector,
    (state: IRpaDashboardUIPathState) => state.jobsList
);

export const getUIPathQueueitemsListSelector = createSelector(
    uipathDashboardSelector,
    (state: IRpaDashboardUIPathState) => state.queueitemsList
);

export const UIPathRetryJobSelector = createSelector(
    uipathDashboardSelector,
    (state: IRpaDashboardUIPathState) => state.jobRetried
);

export const UIPathRetryQueueitemSelector = createSelector(
    uipathDashboardSelector,
    (state: IRpaDashboardUIPathState) => state.queueitemRetried
);

export const getUIPathJobsDataSelector = createSelector(
    uipathDashboardSelector,
    (state: IRpaDashboardUIPathState) => state.jobsData
);

export const getUipathErrorSelector = createSelector(
    uipathDashboardSelector,
    (state: IRpaDashboardUIPathState) => state.isError
);

export const getUIPathQueueitemsDataSelector = createSelector(
    uipathDashboardSelector,
    (state: IRpaDashboardUIPathState) => state.queueitemsData
);
